var React = require('react');

function ArrowDownCircleInvertedIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14zm-.389-10.126a.668.668 0 0 0 .777 0l6.3-4.5a.784.784 0 0 0 .194-1.04.672.672 0 0 0-.97-.208L14 16.35l-5.912-4.223a.671.671 0 0 0-.97.208.784.784 0 0 0 .193 1.04l6.3 4.5z","fill":"#000"}));
}

ArrowDownCircleInvertedIcon.defaultProps = {"width":"28","height":"28","fill":"none"};

module.exports = ArrowDownCircleInvertedIcon;

ArrowDownCircleInvertedIcon.default = ArrowDownCircleInvertedIcon;
